/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 49a830b3 (Tue Jan 27 16:18:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  TranscriptYearCourseWork,
  TranscriptYearCourseWorkFromJSON,
  TranscriptYearCourseWorkToJSON,
} from './'

/**
 * A year for a transcript to relay the year, the course work, and any additional information.
 * @export
 * @interface TranscriptYear
 */
export interface TranscriptYear {
  /**
   * unique identifier.
   * @type number
   * @memberof TranscriptYear
   */
  transcriptYearKey: number
  /**
   *
   * @type number
   * @memberof TranscriptYear
   */
  academicYear?: number
  /**
   * Additional information about the coursework for a year.
   * @type string
   * @memberof TranscriptYear
   */
  notes?: string
  /**
   * The list of classes done for the academic year.
   * @type {Array<TranscriptYearCourseWork>}
   * @memberof TranscriptYear
   */
  transcriptYearCourseWork?: Array<TranscriptYearCourseWork>
  /**
   * Total credits for the transcriptYear, this field is calculated on the frontend
   * @type number
   * @memberof TranscriptYear
   */
  totalCredits?: number
  /**
   * GPA of the transcriptYear, this field is calculated on the frontend
   * @type number
   * @memberof TranscriptYear
   */
  gpa?: number
}

export function TranscriptYearFromJSON(json: any): TranscriptYear {
  return TranscriptYearFromJSONTyped(json, false)
}

export function TranscriptYearFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TranscriptYear {
  if (json === undefined || json === null) {
    return json
  }
  return {
    transcriptYearKey: json['transcriptYearKey'],
    academicYear: !exists(json, 'academicYear')
      ? undefined
      : json['academicYear'],
    notes: !exists(json, 'notes') ? undefined : json['notes'],
    transcriptYearCourseWork: !exists(json, 'transcriptYearCourseWork')
      ? undefined
      : (json['transcriptYearCourseWork'] as Array<any>).map(
          TranscriptYearCourseWorkFromJSON
        ),
    totalCredits: !exists(json, 'totalCredits')
      ? undefined
      : json['totalCredits'],
    gpa: !exists(json, 'gpa') ? undefined : json['gpa'],
  }
}

export function TranscriptYearToJSON(value?: TranscriptYear | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    transcriptYearKey: value.transcriptYearKey,
    academicYear: value.academicYear,
    notes: value.notes,
    transcriptYearCourseWork:
      value.transcriptYearCourseWork === undefined
        ? undefined
        : (value.transcriptYearCourseWork as Array<any>).map(
            TranscriptYearCourseWorkToJSON
          ),
    totalCredits: value.totalCredits,
    gpa: value.gpa,
  }
}
